import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { useTranslation } from "react-i18next";
import { MyInstumentTuneBookingStyled } from "./styled";
import moment from "moment";

const MyInstumentTuneBooking = ({
  theme_standard,
  appointment_date,
  appointment_time,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const { t, i18n } = useTranslation(["profile", "common"]);

  return (
    <MyInstumentTuneBookingStyled className={customClass} lang={i18n.language}>
      <div className="booking_status_wrap">
        <div className="booking_status">{t("You have booked piano tuning", { ns: "common" })}</div>
      </div>
      <div className="booking_date">
        <div className="date">
          วันที {moment(appointment_date).format("DD/MM/YYYY")}
        </div>
        <div className="time">เวลา {appointment_time} น.</div>
      </div>
      {/*  <div className="booking_desc">
        ท่านจะได้รับ SMS แจ้งเตือน วันที่{" "}
        {moment(appointment_date).subtract(1, "day").format("DD/MM/YYYY")} เวลา
        10.00 น.
      </div> */}
      <div className="booking_desc mb15">
        ช่างจะโทร Confirm ท่านอีกครั้งภายในวันที่{" "}
        {moment(appointment_date).subtract(1, "day").format("DD/MM/YYYY")}
      </div>
      <div className="booking_footer">
        หากท่านต้องการ เปลี่ยนแปลงเวลา กรุณาโทร 02-215-2626
      </div>
    </MyInstumentTuneBookingStyled>
  );
};

MyInstumentTuneBooking.propTypes = {};

export default MyInstumentTuneBooking;
